
import { City, CityPoint, LatitudeLongitude } from "@/models/City";
import { MapOptions } from "@/models/Map";
import { Component, Vue, Prop } from "vue-property-decorator";
import Map from "../Base/Map.vue";
import { cloneDeep, forIn } from "lodash";
import { QuestMapPoi } from "@/models/MapPois/Quest/QuestMapPoi";

@Component({
  components: { Map },
})
class AutoAssignBox extends Vue {
  @Prop({ default: "" }) readonly cityData!: City;
  @Prop({ default: "" }) readonly mapPoi!: QuestMapPoi[];
  @Prop({ default: "" }) readonly gameKey!: string;
  place: any = {};
  lat = 0;
  lng = 0;
  radius = 750;
  numberOfCityPoints = 0;
  searchFilter = "START_ZONE";
  cityDataPoints: City = cloneDeep(this.cityData);
  items = [];
  fields = [
    {
      key: "title.en",
      label: "Poi Name",
      sortable: true,
    },
    {
      key: "ignore",
      label: "Ignore",
      sortable: true,
    },
  ];
  ignoreList: string[] = [];

  get centerPoint(): any {
    return { latitude: this.lat, longitude: this.lng };
  }

  get getCityPointsCount(): number {
    return this.numberOfCityPoints;
  }

  get getRadius(): number {
    return this.radius;
  }
  created(): void {
    this.lat = this.cityData.centre_point.latitude;
    this.lng = this.cityData.centre_point.longitude;
    this.calculateCitiesInGeoFence();
    this.$v.$touch();
  }
  cancel(): void {
    this.$emit("closeDialog");
  }
  get getCityMarkerPoints(): MapOptions[] {
    var arr = [];
    var cityCentreMarker: MapOptions = {
      position: {
        lat: this.lat,
        lng: this.lng,
      },
      title: "MapMarker",
      draggable: true,
      clickable: false,
      slug: "",
      zIndex: 10000,
      radius: this.getRadius,
    };
    arr.push(cityCentreMarker);
    forIn(this.cityData.locations, (val: CityPoint) => {
      if (val.slug !== "centre_point") {
        var locationMarker: MapOptions = {
          position: {
            lat: val.lat_long.latitude,
            lng: val.lat_long.longitude,
          },
          title: val.name.en,
          slug: val.slug,
          draggable: false,
          clickable: true,
          zIndex: 100,
          radius: 10,
          icon: require("@/assets/images/map/city-gray.svg"),
        };

        arr.push(locationMarker);
      }
    });
    return arr;
  }

  arePointsNear(
    checkPoint: LatitudeLongitude,
    centerPoint: LatitudeLongitude,
    km: number
  ): boolean {
    var ky = 40000 / 360;
    var kx = Math.cos((Math.PI * centerPoint.latitude) / 180.0) * ky;
    var dx = Math.abs(centerPoint.longitude - checkPoint.longitude) * kx;
    var dy = Math.abs(centerPoint.latitude - checkPoint.latitude) * ky;
    return Math.sqrt(dx * dx + dy * dy) <= km;
  }

  calculateCitiesInGeoFence(): void {
    this.cityDataPoints = cloneDeep(this.cityData);
    this.numberOfCityPoints = 0;
    forIn(this.cityDataPoints.locations, (val: CityPoint) => {
      if (
        !this.arePointsNear(
          val.lat_long,
          this.cityDataPoints.centre_point,
          this.getRadius / 1000
        )
      ) {
        delete this.cityDataPoints.locations[val.slug];
      } else {
        this.numberOfCityPoints++;
      }
    });
  }

  mapData(place: any): void {
    this.place = place;
    this.lat = place.latitude;
    this.lng = place.longitude;
  }

  closeModal(): void {
    this.$bvModal.hide("modal-auto-assign");
  }

  openModal(): void {
    this.$bvModal.show("modal-auto-assign");
  }

  autoAssignPoints(): void {
    var data = {
      gameKey: this.gameKey,
      mapPoi: this.mapPoi,
      cityData: this.cityDataPoints,
      ignoreList: this.ignoreList,
    };
    this.$store.dispatch("mapPoiStore/randomisePoiPoints", data).then(() => {
      this.$bvModal.hide("modal-auto-assign");
      this.$emit("closeDialog");
    });
  }

  addToIgnoreList(key: string, selected: any): void {
    if (selected) {
      this.ignoreList.push(key);
    } else {
      this.ignoreList = this.ignoreList.filter((obj) => obj !== key);
    }
  }

  filterStartPoint(row: QuestMapPoi): boolean {
    if (row.title.en !== "START_ZONE") {
      return true;
    }
    return false;
  }
}

export default AutoAssignBox;
